import { render, staticRenderFns } from "./StaticCard.vue?vue&type=template&id=9bf2a136&scoped=true&"
import script from "./StaticCard.vue?vue&type=script&lang=js&"
export * from "./StaticCard.vue?vue&type=script&lang=js&"
import style0 from "./StaticCard.vue?vue&type=style&index=0&id=9bf2a136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf2a136",
  null
  
)

export default component.exports